import { Component, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-or-cancel-modal',
  templateUrl: './confirm-or-cancel-modal.component.html',
  styleUrls: ['./confirm-or-cancel-modal.component.scss']
})

/**
 * Confirm or Cancel Modal Component is meant to serve as a generic
 * modal for cases where we want the user to either Confirm or Cancel
 * some action.
 * 
 * Calling component will know if user confirmed or cancelled based on
 * event emitter events
 * 
 */
export class ConfirmOrCancelModalComponent   {

  title: string;
  body: string;

  cancelBtnTxt: string;
  confirmBtnTxt: string;

  dismissAllOnClose: boolean;

  @Output() confirmBtnClicked: EventEmitter<boolean> = new EventEmitter(); 

  constructor(private activeModalService: NgbActiveModal, private modalService: NgbModal) {
  }
 
  cancel() {
    this.confirmBtnClicked.emit(false);
    if (this.dismissAllOnClose) {
      this.modalService.dismissAll();
    } else {
      this.activeModalService.dismiss();
    }
  }

  confirm() {
    this.confirmBtnClicked.emit(true);
    this.activeModalService.dismiss();
  }
}
